import Typography from '@components/v2/ui/Typography/Typography';
import { Grid } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../lang/LangEnum';
import useOrderBookStore from '../../stores/OrderBook/orderBook.store';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { useTranslation } from '../translation/TranslationContext';

const values = {
  HAVE_MANY_ORDERS: LangEnum.ORDER_BOOK_SUBTITLE_MORE_ORDERS,
  HAVE_ONE_ORDER: LangEnum.ORDER_BOOK_SUBTITLE_ONE_ORDER,
  EMPTY_ORDERS: LangEnum.ORDER_BOOK_SUBTITLE_EMPTY_ORDERS,
};

const OrderActiveSubtitle = () => {
  const [orders, selectedOrder] = useOrderBookStore(
    useShallow((state) => [state.orders, state.selectedOrder]),
  );
  const { translate } = useTranslation();

  const getOrderActiveSubtitle = () => {
    if (selectedOrder) {
      return values.HAVE_MANY_ORDERS;
    }

    return orders.length === 0 ? values.EMPTY_ORDERS : values.HAVE_ONE_ORDER;
  };

  return (
    <Grid container spacing={1}>
      <Grid size="grow">
        <Typography
          variant="body2"
          color="textSecondary"
          testId={ActiveOrderTestIds.ORDER_SELECTED_MESSAGE}
        >
          {translate(getOrderActiveSubtitle())}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default OrderActiveSubtitle;
